import {get} from 'lodash';

export default (state = {}, {clientId, client}: any) => {
  return {
    ...state,
    allProfiles: {
      ...get(state, 'allProfiles', {}),
      [clientId]: {
        ...get(state, `allProfiles.${clientId}`, {}),
        ...client,
      },
    },
  };
};
